// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3k0OP","textContent":"style_textContent__2j5OP","normalCase":"style_normalCase__1RtUe"};